import { Model } from 'infra/model'
import { observable, makeObservable } from 'mobx'

export interface FeaturePreviewLocalStorage {
  id: string
  answered: boolean
}
export default class FeaturePreview extends Model<
  FeaturePreviewLocalStorage,
  FeaturePreview
> {
  @observable id = ''
  @observable answered = false

  constructor() {
    super()

    makeObservable(this)
  }

  parse(json: Partial<FeaturePreviewLocalStorage>): Partial<FeaturePreview> {
    return {
      id: json.id,
      answered: json.answered,
    }
  }
}
